import logger from '../../helpers/logger';
import MonitoredDevice, { DeviceStatusFlags, KioDeviceStatus } from '../MonitoredDevice';
import DeviceRegistry from '../DeviceRegistry';
import MagtekCardReaderCallback from './MagtekCardReaderCallback';
import MagtekCardReaderCardData from './MagtekCardReaderCardData';

export default class MagTekCardReader implements MonitoredDevice {
	private callback?: MagtekCardReaderCallback;

	constructor(callback: MagtekCardReaderCallback) {
		this.callback = callback;
		DeviceRegistry.register('mthidmsr', (data) => this.handleCardSwipe('mthidmsr', data));
		DeviceRegistry.register('mtmsr', (data) => this.handleCardSwipe('mtmsr', data));
	}

	/**
	 * Get the status of the device.
	 * @todo Implement actual status checking logic once KioDevice.getStatus() is available.
	 */
	getStatus(): KioDeviceStatus {
		const note = 'KioDevice.getStatus() is called, but Kioware doesn\'t update the status, so it always returns "OK".';
		logger.logCardReader.warn({}, note);
		return {
			statusBits: DeviceStatusFlags.Ok,
			details: {
				Note: note,
			},
		};
	}

	private handleCardSwipe(deviceName: string, dataObject: KioDeviceDataList) {
		try {
			logger.debug.log(`Data from Device ${deviceName ?? ''}:`, dataObject);
			const magTekData = (dataObject as MagTekKioDeviceDataList).DataList[0];
			const data = new MagtekCardReaderCardData(magTekData);
			this.callback?.(data);
		} catch (error) {
			logger.logCardReader.error({}, 'Error scanning card using MagTek reader', error);
		}
	}

	Clean = () => {
		DeviceRegistry.unregister('mthidmsr');
		DeviceRegistry.unregister('mtmsr');
	};
}
